import React from 'react';
import { useIsAdmin, useIsManager, useIsUser } from 'hooks';
import User from './user';
import Management from './management';

const Status = ({ ...rest }) => {
  const isAdmin = useIsAdmin();
  const isManager = useIsManager();
  const isUser = useIsUser();

  return (
    <>
      {isUser ? <User {...rest} /> : null}
      {isAdmin || isManager ? <Management {...rest} /> : null}
    </>
  );
};

export default Status;
